(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 49474:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ compareAsc; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name compareAsc
 * @category Common Helpers
 * @summary Compare the two dates and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return 1 if the first date is after the second,
 * -1 if the first date is before the second or 0 if dates are equal.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to compare
 * @param {Date|Number} dateRight - the second date to compare
 * @returns {Number} the result of the comparison
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989:
 * const result = compareAsc(new Date(1987, 1, 11), new Date(1989, 6, 10))
 * //=> -1
 *
 * @example
 * // Sort the array of dates:
 * const result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareAsc)
 * //=> [
 * //   Wed Feb 11 1987 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Sun Jul 02 1995 00:00:00
 * // ]
 */

function compareAsc(dirtyDateLeft, dirtyDateRight) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var dateLeft = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateLeft);
  var dateRight = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateRight);
  var diff = dateLeft.getTime() - dateRight.getTime();

  if (diff < 0) {
    return -1;
  } else if (diff > 0) {
    return 1; // Return 0 if diff is 0; return NaN if diff is NaN
  } else {
    return diff;
  }
}

/***/ }),

/***/ 45301:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(67242);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 95500:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "t": function() { return /* reexport */ AuthStatus; },
  "j": function() { return /* reexport */ authEvent; }
});

// EXTERNAL MODULE: ./analytics/push/push.ts
var push = __webpack_require__(7820);
// EXTERNAL MODULE: ./interfaces/GoogleAnalytics.ts
var GoogleAnalytics = __webpack_require__(74149);
;// CONCATENATED MODULE: ./analytics/events/auth/event.ts


var AuthStatus;
(function(AuthStatus) {
    AuthStatus["Success"] = 'success';
    AuthStatus["Failure"] = 'error';
})(AuthStatus || (AuthStatus = {}));
var authEvent = function(method, action) {
    (0,push/* pushEvent */.A)({
        event: GoogleAnalytics/* AnalyticsEventType.AUTH */.n.AUTH,
        eventProperties: {
            eventCategory: 'auth',
            eventAction: action,
            eventLabel: method
        }
    });
};

;// CONCATENATED MODULE: ./analytics/events/auth/index.ts



/***/ }),

/***/ 53566:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": function() { return /* reexport */ pageLoadEvent; }
});

// EXTERNAL MODULE: ./analytics/push/push.ts
var push = __webpack_require__(7820);
// EXTERNAL MODULE: ./interfaces/GoogleAnalytics.ts
var GoogleAnalytics = __webpack_require__(74149);
;// CONCATENATED MODULE: ./analytics/events/pageLoad/event.ts


var pageLoadEvent = function(pageName, platformLanguage) {
    var ref;
    var platform = (navigator === null || navigator === void 0 ? void 0 : (ref = navigator.userAgentData) === null || ref === void 0 ? void 0 : ref.platform) || (navigator === null || navigator === void 0 ? void 0 : navigator.platform) || 'unknown';
    (0,push/* pushEvent */.A)({
        event: GoogleAnalytics/* AnalyticsEventType.PAGELOAD */.n.PAGELOAD,
        eventProperties: {
            pageName: pageName,
            platform: platform,
            platformLanguage: platformLanguage
        }
    });
};

;// CONCATENATED MODULE: ./analytics/events/pageLoad/index.ts



/***/ }),

/***/ 71592:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "un": function() { return /* reexport */ formatPhoneNumber; },
  "aV": function() { return /* reexport */ providerMapping; },
  "OA": function() { return /* reexport */ sendOTP; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./api/axios/baseAxios.ts
var baseAxios = __webpack_require__(25767);
// EXTERNAL MODULE: ./api/urls.ts
var urls = __webpack_require__(83072);
// EXTERNAL MODULE: ./interfaces/Auth.ts
var Auth = __webpack_require__(88184);
// EXTERNAL MODULE: ./utilities/removeSpaces/removeSpaces.ts
var removeSpaces = __webpack_require__(79219);
;// CONCATENATED MODULE: ./api/requests/sendOTP/request.ts





function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var providerMapping = _defineProperty({}, Auth/* AuthMethod.PHONE */.H.PHONE, 'sms');
var formatPhoneNumber = function(param) {
    var value = param.value, dialCode = param.dialCode;
    return (0,removeSpaces/* removeSpaces */.I)(value.slice(dialCode === null || dialCode === void 0 ? void 0 : dialCode.length, value.length));
};
var sendOTP = function() {
    var _ref = _asyncToGenerator(runtime_default().mark(function _callee(values) {
        var formattedValue;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    formattedValue = formatPhoneNumber(values.phone);
                    _ctx.next = 3;
                    return baseAxios/* default.get */.Z.get(urls/* URLS.getOTPCode */.n.getOTPCode, {
                        params: _defineProperty({
                            provider: providerMapping[values.type]
                        }, values.type, formattedValue)
                    });
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function sendOTP(values) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./api/requests/sendOTP/index.ts



/***/ }),

/***/ 20742:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "oK": function() { return /* binding */ MainScreen; },
/* harmony export */   "Aq": function() { return /* binding */ Background; },
/* harmony export */   "n5": function() { return /* binding */ FormWrapper; },
/* harmony export */   "G": function() { return /* binding */ StyledFlex; },
/* harmony export */   "br": function() { return /* binding */ TitleTypographyWrapper; },
/* harmony export */   "vA": function() { return /* binding */ SeoContent; },
/* harmony export */   "d8": function() { return /* binding */ Bold; },
/* harmony export */   "D7": function() { return /* binding */ TextContent; },
/* harmony export */   "Mg": function() { return /* binding */ PaperCard; },
/* harmony export */   "aV": function() { return /* binding */ List; },
/* harmony export */   "qm": function() { return /* binding */ BlockWrapper; }
/* harmony export */ });
/* unused harmony export StyledLink */
/* harmony import */ var components_ui_Box__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97243);
/* harmony import */ var components_ui_Flex__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69029);
/* harmony import */ var components_ui_Paper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19365);
/* harmony import */ var polished__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(95044);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50445);
/* harmony import */ var styles_mixins_page__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25013);






function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  background-color: ",
        ";\n  padding: 0 16px;\n  display: flex;\n  align-items: stretch;\n  flex-direction: column;\n  justify-content: center;\n  z-index: 2;\n\n  @media only screen and (max-width: 1320px) {\n    margin-bottom: 0;\n  }\n\n  h1 {\n    @media only screen and (max-width: 948px) {\n      font-size: 22px;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  z-index: -1;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  img {\n    background-color: ",
        ";\n  }\n  &:before {\n    z-index: 2;\n    content: '';\n    position: absolute;\n    pointer-events: none;\n    left: 0;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  @media screen and (max-width: 1130px) {\n    // height: 375px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: 24px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  h1 {\n    white-space: pre-wrap;\n    line-height: 1.2;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  line-height: 24px;\n  column-gap: 67px;\n\n  > div {\n    &:nth-child(2) {\n      max-width: 555px;\n      @media screen and (max-width: 800px) {\n        max-width: max-content;\n      }\n    }\n  }\n\n  @media screen and (max-width: 800px) {\n    flex-direction: column;\n    row-gap: 16px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  font-weight: bold;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  max-width: 460px;\n  @media screen and (max-width: 800px) {\n    max-width: max-content;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 24px;\n  @media screen and (max-width: 800px) {\n    padding: 16px;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n            &:before {\n              margin-right: 4px;\n              font-size: 14px;\n              font-family: 'Open Sans', sans-serif;\n              letter-spacing: -0.4px;\n              content: attr(data-index);\n            }\n          "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n            position: relative;\n            padding-bottom: 8px;\n            margin-top: 8px;\n            &:before {\n              content: '';\n              width: 100%;\n              height: 1px;\n              position: absolute;\n              bottom: 0;\n              left: 0;\n              right: 0;\n              background-color: ",
        ";\n            }\n\n            &:last-child {\n              &:before {\n                display: none;\n              }\n            }\n          "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  list-style-type: none;\n  color: #212121;\n  li {\n    ",
        "\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  a {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 40px 0;\n  background-color: ",
        ";\n\n  button {\n    width: 100%;\n  }\n\n  @media screen and (max-width: 1180px) {\n    padding: 32px 0;\n    h5 {\n      font-size: 22px;\n    }\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
var MainScreen = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-def82787-0"
})(_templateObject(), (0,styles_mixins_page__WEBPACK_IMPORTED_MODULE_4__/* .pageWrapper */ .Y)(true, 90, 0), function(param) {
    var theme = param.theme;
    return theme.palette.primary.MAIN;
});
var Background = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-def82787-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.palette.primary.MAIN;
}, function(param) {
    var theme = param.theme;
    return (0,polished__WEBPACK_IMPORTED_MODULE_5__/* .transparentize */ .DZ)(0.4, theme.palette.primary.MAIN);
});
var FormWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-def82787-2"
})(_templateObject2());
var StyledFlex = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(components_ui_Flex__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .k).withConfig({
    componentId: "sc-def82787-3"
})(_templateObject3());
var TitleTypographyWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-def82787-4"
})(_templateObject4());
var SeoContent = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-def82787-5"
})(_templateObject5());
var Bold = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-def82787-6"
})(_templateObject6());
var TextContent = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(components_ui_Box__WEBPACK_IMPORTED_MODULE_0__/* .Box */ .x).withConfig({
    componentId: "sc-def82787-7"
})(_templateObject7());
var PaperCard = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(components_ui_Paper__WEBPACK_IMPORTED_MODULE_2__/* .Paper */ .X).withConfig({
    componentId: "sc-def82787-8"
})(_templateObject8());
var List = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].ul.withConfig */ .ZP.ul.withConfig({
    componentId: "sc-def82787-9"
})(_templateObject11(), function(param) {
    var _decimal = param.decimal, decimal = _decimal === void 0 ? false : _decimal, theme = param.theme;
    return decimal ? (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject9()) : (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject10(), theme.palette.core.GRAY);
});
var StyledLink = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].a.withConfig */ .ZP.a.withConfig({
    componentId: "sc-def82787-10"
})(_templateObject12(), function(param) {
    var theme = param.theme;
    return theme.palette.core.BLUE;
}, function(param) {
    var theme = param.theme;
    return theme.palette.core.BLUE;
});
var BlockWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-def82787-11"
})(_templateObject13(), function(param) {
    var bg = param.bg, theme = param.theme;
    return bg || theme.palette.core.WHITE;
});


/***/ }),

/***/ 38240:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ UnfinishedBooking; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./api/axios/baseAxios.ts
var baseAxios = __webpack_require__(25767);
// EXTERNAL MODULE: ./api/urls.ts
var urls = __webpack_require__(83072);
// EXTERNAL MODULE: ./core/env.ts
var env = __webpack_require__(81622);
;// CONCATENATED MODULE: ./api/requests/cancelBooking/request.ts




function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var cancelBooking = function() {
    var _ref = _asyncToGenerator(runtime_default().mark(function _callee(bookingId) {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return baseAxios/* default.delete */.Z["delete"](urls/* URLS.cancelBooking */.n.cancelBooking(bookingId), {
                        headers: {
                            'Authorization-Service': "Bearer ".concat(env/* SERVICE_TOKEN */.UQ)
                        }
                    });
                case 2:
                    return _ctx.abrupt("return", true);
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function cancelBooking(bookingId) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./api/requests/cancelBooking/index.ts


// EXTERNAL MODULE: ./api/requests/getBooking/index.ts + 1 modules
var getBooking = __webpack_require__(96045);
// EXTERNAL MODULE: ./components/ui/Box/index.ts + 2 modules
var Box = __webpack_require__(97243);
// EXTERNAL MODULE: ./components/ui/Flex/index.ts + 8 modules
var Flex = __webpack_require__(69029);
// EXTERNAL MODULE: ./components/ui/Icon/index.ts + 3 modules
var Icon = __webpack_require__(37033);
// EXTERNAL MODULE: ./components/ui/Typography/index.ts + 2 modules
var Typography = __webpack_require__(59253);
// EXTERNAL MODULE: ./core/constants.ts
var constants = __webpack_require__(43566);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/parseISO/index.js
var parseISO = __webpack_require__(23855);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/compareAsc/index.js
var compareAsc = __webpack_require__(49474);
// EXTERNAL MODULE: ./interfaces/Booking.ts
var Booking = __webpack_require__(1538);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(51759);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-use/esm/useToggle.js
var useToggle = __webpack_require__(89211);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(50445);
// EXTERNAL MODULE: ./utilities/localStorage/setLocalStorageItem.ts
var setLocalStorageItem = __webpack_require__(10047);
// EXTERNAL MODULE: ./utilities/localStorage/getLocalStorageItem.ts
var getLocalStorageItem = __webpack_require__(86318);
// EXTERNAL MODULE: ./components/ui/Button/index.ts + 2 modules
var Button = __webpack_require__(41001);
;// CONCATENATED MODULE: ./components/shared/UnfinishedBooking/styles.ts



function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  right: 7vw;\n  z-index: 10;\n  border-radius: 8px;\n  position: fixed;\n  bottom: 18px;\n  width: 365px;\n  overflow: hidden;\n  box-shadow: 0px 0px 10px rgba(228, 60, 74, 0.14), 0px 0px 14px rgba(228, 60, 74, 0.12);\n  background: ",
        ";\n  z-index: 1000;\n\n  @media screen and (min-width: 1440px) {\n    right: calc((100vw - 1140px) / 2);\n  }\n  @media screen and (max-width: 860px) {\n    bottom: 18px;\n  }\n  @media screen and (max-width: 576px) {\n    right: 16px;\n    width: calc(100vw - 16px * 2);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  top: -5px;\n  right: -15px;\n  opacity: 0.1;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  @media screen and (max-width: 576px) {\n    width: 100%;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  @media screen and (max-width: 576px) {\n    flex-direction: column;\n    row-gap: 8px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ef2602c3-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.palette.core.WHITE;
});
var IconWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ef2602c3-1"
})(_templateObject1());
var StyledButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* Button */.z).withConfig({
    componentId: "sc-ef2602c3-2"
})(_templateObject2());
var ButtonWrapperFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* Flex */.k).withConfig({
    componentId: "sc-ef2602c3-3"
})(_templateObject3());

;// CONCATENATED MODULE: ./components/shared/UnfinishedBooking/component.tsx


















function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function component_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function component_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                component_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                component_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var UnfinishedBooking = function() {
    var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
    var t = (0,useTranslation/* default */.Z)().t;
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(null), booking = ref[0], setBooking = ref[1];
    var ref1 = _slicedToArray((0,useToggle/* default */.Z)(false), 2), isLoading = ref1[0], toggleLoading = ref1[1];
    var ref2 = _slicedToArray((0,useToggle/* default */.Z)(false), 2), cancellationBookingInProgress = ref2[0], toggleCancellationBookingInProgress = ref2[1];
    var closeUnfinishedBooking = function() {
        var _ref = component_asyncToGenerator(runtime_default().mark(function _callee() {
            var withApiRequest, _args = arguments;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        withApiRequest = _args.length > 0 && _args[0] !== void 0 ? _args[0] : true;
                        toggleCancellationBookingInProgress(true);
                        _ctx.prev = 2;
                        if (!withApiRequest) {
                            _ctx.next = 6;
                            break;
                        }
                        _ctx.next = 6;
                        return cancelBooking(booking.bookingNumber);
                    case 6:
                        _ctx.prev = 6;
                        setBooking(null);
                        (0,setLocalStorageItem/* setLocalStorageItem */.D)(constants/* LOCAL_STORAGE_KEYS.UNFINISHED_BOOKING */.dA.UNFINISHED_BOOKING, null);
                        toggleCancellationBookingInProgress(false);
                        return _ctx.finish(6);
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    ,
                    6,
                    11
                ]
            ]);
        }));
        return function closeUnfinishedBooking() {
            return _ref.apply(this, arguments);
        };
    }();
    var goToUnfinishedBooking = function() {
        toggleLoading(true);
        var bookingUrl = "/booking/".concat((booking === null || booking === void 0 ? void 0 : booking.bookingNumber) || '', "/passengers");
        void router.push(bookingUrl);
    };
    var isExpired = function(expires) {
        var expiresDate = (0,parseISO["default"])(expires);
        return Boolean((0,compareAsc/* default */.Z)(new Date(), expiresDate) + 1);
    };
    var fetchBooking = function() {
        var _ref = component_asyncToGenerator(runtime_default().mark(function _callee(id) {
            var payload;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return (0,getBooking/* getBooking */.l)(id);
                    case 2:
                        payload = _ctx.sent;
                        if (!(!payload || payload.status === Booking/* BookingState.Canceled */.m2.Canceled)) {
                            _ctx.next = 5;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 5:
                        setBooking(payload);
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function fetchBooking(id) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        var unfinishedBooking = (0,getLocalStorageItem/* getLocalStorageItem */.l)(constants/* LOCAL_STORAGE_KEYS.UNFINISHED_BOOKING */.dA.UNFINISHED_BOOKING);
        if (!unfinishedBooking) return function() {};
        if (isExpired(unfinishedBooking.expires)) {
            void closeUnfinishedBooking(false);
            return function() {};
        }
        void fetchBooking(unfinishedBooking.id);
        return function() {};
    }, []);
    if (!booking) return null;
    var getDestinations = function() {
        var outboundTariffSegment = booking.outboundBookingTariffSegments[0];
        var inboundTariffSegment = booking.inboundBookingTariffSegments[0];
        var getDestinationBySegment = function(segment) {
            if (!segment) return '';
            return "".concat(segment.journeySegment.departureStation.name, " - ").concat(segment.journeySegment.arrivalStation.name);
        };
        var destinations = [
            getDestinationBySegment(outboundTariffSegment),
            getDestinationBySegment(inboundTariffSegment), 
        ];
        return destinations.filter(function(d) {
            return Boolean(d);
        }).join(', ');
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
                padding: 16,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                        typography: theme.typography.variants.title.H2,
                        color: theme.palette.secondary.MAIN,
                        children: t('unfinishedBooking:unfinishedPayment')
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                        marginTop: 8,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                            children: getDestinations()
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* Typography */.Z, {
                            children: [
                                " ",
                                t('unfinishedBooking:continue')
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                        marginTop: 24,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonWrapperFlex, {
                            container: true,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* Flex */.k, {
                                    item: true,
                                    grow: 1,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                                        isLoading: cancellationBookingInProgress,
                                        onClick: function() {
                                            return closeUnfinishedBooking();
                                        },
                                        type: "button",
                                        width: 162,
                                        fill: "outlined",
                                        variant: "flat",
                                        hoverColor: theme.palette.secondary.MAIN,
                                        children: t('core:close')
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* Flex */.k, {
                                    item: true,
                                    grow: 1,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                                        onClick: goToUnfinishedBooking,
                                        isLoading: isLoading,
                                        type: "button",
                                        width: 162,
                                        fill: "outlined",
                                        variant: "flat",
                                        hoverColor: theme.palette.primary.MAIN,
                                        children: t('core:continue')
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                    icon: theme.icons.stepper.PassengerData,
                    width: 105,
                    height: 82,
                    color: theme.palette.secondary.MAIN
                })
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./components/shared/UnfinishedBooking/index.ts



/***/ }),

/***/ 43566:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "dA": function() { return /* binding */ LOCAL_STORAGE_KEYS; },
/* harmony export */   "a3": function() { return /* binding */ PAGE_NAMES; }
/* harmony export */ });
/* unused harmony export BOOKING_EXPIRE_MINUTES */
var BOOKING_EXPIRE_MINUTES = 15;
var LOCAL_STORAGE_KEYS = {
    UNFINISHED_BOOKING: 'UNFINISHED_BOOKING',
    BOOKING_UPDATE: function(id) {
        return "BOOKING_UPDATE_".concat(id);
    }
};
var PAGE_NAMES = {
    HOMEPAGE: 'homepage',
    RESULTS: 'results',
    CHECKOUT: 'checkout',
    PURCHASE: 'purchase',
    REFUND: 'refund'
};


/***/ }),

/***/ 88184:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ AuthPurpose; },
/* harmony export */   "H": function() { return /* binding */ AuthMethod; }
/* harmony export */ });
var AuthPurpose;
(function(AuthPurpose) {
    AuthPurpose["PRINT"] = 'print';
    AuthPurpose["REFUND"] = 'refund';
})(AuthPurpose || (AuthPurpose = {}));
var AuthMethod;
(function(AuthMethod) {
    AuthMethod["PHONE"] = 'phone';
})(AuthMethod || (AuthMethod = {}));


/***/ }),

/***/ 73918:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ CountryCode; }
/* harmony export */ });
var CountryCode;
(function(CountryCode) {
    CountryCode["KZ"] = 'kz';
    CountryCode["RU"] = 'ru';
    CountryCode["UZ"] = 'uz';
    CountryCode["KG"] = 'kg';
    CountryCode["TM"] = 'tm';
    CountryCode["BY"] = 'by';
})(CountryCode || (CountryCode = {}));


/***/ }),

/***/ 67242:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* reexport */ HomePage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./analytics/events/pageLoad/index.ts + 1 modules
var pageLoad = __webpack_require__(53566);
// EXTERNAL MODULE: ./components/shared/MetaHead/index.ts + 11 modules
var MetaHead = __webpack_require__(82764);
// EXTERNAL MODULE: ./components/shared/PopularRoutes/index.ts + 7 modules
var PopularRoutes = __webpack_require__(12771);
// EXTERNAL MODULE: ./components/shared/SearchTicketsForm/index.ts + 22 modules
var SearchTicketsForm = __webpack_require__(31561);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react-phone-input-2/lib/style.css
var style = __webpack_require__(86408);
// EXTERNAL MODULE: ./analytics/events/auth/index.ts + 1 modules
var auth = __webpack_require__(95500);
// EXTERNAL MODULE: ./api/requests/sendOTP/index.ts + 1 modules
var sendOTP = __webpack_require__(71592);
// EXTERNAL MODULE: ./components/ui/Box/index.ts + 2 modules
var Box = __webpack_require__(97243);
// EXTERNAL MODULE: ./components/ui/Typography/index.ts + 2 modules
var Typography = __webpack_require__(59253);
// EXTERNAL MODULE: ./interfaces/Auth.ts
var Auth = __webpack_require__(88184);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(51759);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-phone-input-2/lib/lib.js
var lib = __webpack_require__(67555);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./node_modules/react-phone-input-2/lang/ru.json
var ru = __webpack_require__(65865);
// EXTERNAL MODULE: ./node_modules/react-use/esm/useToggle.js
var useToggle = __webpack_require__(89211);
// EXTERNAL MODULE: ./schemas/phones/index.ts
var phones = __webpack_require__(7476);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(50445);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82580);
// EXTERNAL MODULE: ./utilities/validatePhone/index.ts + 1 modules
var validatePhone = __webpack_require__(34306);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
;// CONCATENATED MODULE: ./components/shared/SignInForm/hooks/useForm/hook.ts





function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
// eslint-disable-next-line @typescript-eslint/no-unsafe-argument
es/* addMethod */.kM(es/* string */.Z_, 'validatePhone', validatePhone/* validatePhone */.a$);
var defaultInitialValues = {
    type: Auth/* AuthMethod.PHONE */.H.PHONE,
    phone: {
        value: '',
        countryCode: '',
        dialCode: ''
    }
};
var useForm = function(initialValues, onSubmit) {
    var t = (0,useTranslation/* default */.Z)('returnPrintForm').t;
    var validationSchema = es/* object */.Ry().shape({
        phone: es/* object */.Ry().shape({
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-call
            value: es/* string */.Z_().required(t('phone.required'))// eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            .validatePhone(t('phone.incorrect')),
            countryCode: es/* string */.Z_().required(t('phone.required')),
            dialCode: es/* string */.Z_()
        })
    });
    return (0,formik_esm/* useFormik */.TA)({
        initialValues: _objectSpread({}, defaultInitialValues, initialValues),
        onSubmit: onSubmit,
        validationSchema: validationSchema,
        validateOnMount: false,
        validateOnChange: false,
        validateOnBlur: true
    });
};

;// CONCATENATED MODULE: ./components/shared/SignInForm/hooks/useForm/index.ts


// EXTERNAL MODULE: ./components/ui/Button/index.ts + 2 modules
var Button = __webpack_require__(41001);
// EXTERNAL MODULE: ./components/ui/Flex/index.ts + 8 modules
var Flex = __webpack_require__(69029);
;// CONCATENATED MODULE: ./components/shared/SignInForm/styles.ts



function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  .phone {\n    &__container {\n      display: flex;\n      flex-direction: row-reverse;\n    }\n\n    &__form-control {\n      border-radius: 0 12px 12px 0;\n      margin: 0;\n      border-color: ",
        ";\n      width: 100%;\n      height: 48px;\n      padding: 14px 16px;\n\n      &::placeholder {\n        color: ",
        ";\n        font-family: 'Open Sans', sans-serif;\n        font-size: 14px;\n        line-height: 18px;\n        letter-spacing: -0.04em;\n      }\n    }\n\n    &__flag-dropdown {\n      width: 53px;\n      position: relative;\n      border-radius: 12px 0 0 12px;\n      border-right: 0;\n      background-color: transparent;\n      border-color: ",
        ";\n\n      .selected-flag {\n        width: 53px;\n        padding: 0 0 0 18px;\n\n        .arrow {\n          border-top-color: ",
        ";\n\n          &.up {\n            border-bottom-color: ",
        ";\n          }\n        }\n      }\n    }\n\n    &__country-list {\n      width: ",
        ";\n      max-height: 220px;\n      margin-top: 4px;\n      padding-top: 17px;\n      padding-bottom: 11px;\n      color: ",
        ";\n      box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);\n      border-radius: 0 0 12px 12px;\n\n      .country {\n        padding: 8px 16px;\n        transition: all 0.2s ease;\n\n        &.highlight {\n          background-color: ",
        ";\n\n          &:hover {\n            background-color: ",
        ";\n          }\n\n          .country-name,\n          .dial-code {\n            color: ",
        ";\n          }\n        }\n\n        &:hover {\n          background-color: ",
        ";\n        }\n      }\n\n      .country-name {\n        color: ",
        ";\n      }\n\n      .dial-code {\n        color: ",
        ";\n      }\n    }\n  }\n\n  .react-tel-input {\n    .invalid-number {\n      &.form-control,\n      &.flag-dropdown {\n        border-color: ",
        ";\n      }\n\n      &.form-control {\n        background-color: transparent;\n      }\n    }\n\n    .open {\n      &.flag-dropdown,\n      &.selected-flag {\n        border-radius: 12px 0 0 12px;\n        background: transparent;\n      }\n    }\n\n    .selected-flag {\n      &:focus,\n      &:hover {\n        background-color: transparent;\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  flex-wrap: nowrap;\n  flex-grow: 1;\n  margin-right: 24px;\n  z-index: 2;\n\n  @media screen and (max-width: 992px) {\n    flex-wrap: wrap;\n    margin-bottom: 24px;\n    margin-right: 0;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  flex-grow: 1;\n\n  @media screen and (max-width: 992px) {\n    flex-grow: 1;\n    flex-basis: auto;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: flex-start;\n\n  @media screen and (max-width: 992px) {\n    align-items: normal;\n    flex-direction: column;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  width: 320px;\n\n  @media screen and (max-width: 992px) {\n    width: 100%;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5204ee75-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.palette.core.LIGHT_GRAY;
}, function(param) {
    var theme = param.theme;
    return theme.palette.core.LIGHT_GRAY;
}, function(param) {
    var theme = param.theme;
    return theme.palette.core.LIGHT_GRAY;
}, function(param) {
    var theme = param.theme;
    return theme.palette.core.DEEP_GRAY;
}, function(param) {
    var theme = param.theme;
    return theme.palette.core.DEEP_GRAY;
}, function(param) {
    var phoneWidth = param.phoneWidth;
    return "".concat(phoneWidth, "px");
}, function(param) {
    var theme = param.theme;
    return theme.palette.core.WHITE;
}, function(param) {
    var theme = param.theme;
    return theme.palette.primary.MAIN;
}, function(param) {
    var theme = param.theme;
    return theme.palette.primary.MAIN;
}, function(param) {
    var theme = param.theme;
    return theme.palette.core.WHITE;
}, function(param) {
    var theme = param.theme;
    return theme.palette.core.VERY_LIGHT_GRAY;
}, function(param) {
    var theme = param.theme;
    return theme.palette.core.BLACK;
}, function(param) {
    var theme = param.theme;
    return theme.palette.core.DEEP_GRAY;
}, function(param) {
    var theme = param.theme;
    return theme.palette.secondary.MAIN;
});
var FlexInputsWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* Flex */.k).withConfig({
    componentId: "sc-5204ee75-1"
})(_templateObject1());
var UserDataInputWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5204ee75-2"
})(_templateObject2());
var StyledFormWrapper = styled_components_browser_esm/* default.form.withConfig */.ZP.form.withConfig({
    componentId: "sc-5204ee75-3"
})(_templateObject3());
var StyledButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* Button */.z).withConfig({
    componentId: "sc-5204ee75-4"
})(_templateObject4());

;// CONCATENATED MODULE: ./components/shared/SignInForm/component.tsx


















function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var SignInForm = function(param1) {
    var purpose = param1.type;
    var ref5, ref1, ref2;
    var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
    var router = (0,next_router.useRouter)();
    var t = (0,useTranslation/* default */.Z)().t;
    var ref3 = (0,react.useState)(0), phoneWidth = ref3[0], setWidth = ref3[1];
    var ref4 = _slicedToArray((0,useToggle/* default */.Z)(false), 2), isFormSubmitting = ref4[0], toggleFormSubmitting = ref4[1];
    var phoneRef = (0,react.useRef)(null);
    var handleFormSubmit = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(values, param) {
            var setErrors, ref;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setErrors = param.setErrors;
                        _ctx.prev = 1;
                        ;
                        toggleFormSubmitting(true);
                        _ctx.next = 6;
                        return (0,sendOTP/* sendOTP */.OA)(values);
                    case 6:
                        _ctx.next = 8;
                        return router.push({
                            pathname: 'otp/[type]',
                            query: {
                                type: purpose,
                                method: Auth/* AuthMethod.PHONE */.H.PHONE,
                                countryCode: values.phone.countryCode,
                                dialCode: "+".concat(String(values.phone.dialCode)),
                                value: phoneRef === null || phoneRef === void 0 ? void 0 : (ref = phoneRef.current) === null || ref === void 0 ? void 0 : ref.value
                            }
                        });
                    case 8:
                        _ctx.next = 15;
                        break;
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t0 = _ctx["catch"](1);
                        setErrors({
                            phone: {
                                value: t("returnPrintForm:phone.apiError")
                            }
                        });
                        toggleFormSubmitting(false);
                        /* Analytics event */ (0,auth/* authEvent */.j)(values.type, auth/* AuthStatus.Failure */.t.Failure);
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    10
                ]
            ]);
        }));
        return function handleFormSubmit(values, _) {
            return _ref.apply(this, arguments);
        };
    }();
    var formik = useForm({}, handleFormSubmit);
    var handleChange = function(value, param) {
        var countryCode = param.countryCode, dialCode = param.dialCode;
        var phone = {
            value: value,
            countryCode: countryCode,
            dialCode: dialCode
        };
        void formik.setFieldValue('phone', phone);
        void formik.setFieldTouched('phone', true);
    };
    var handleBlur = function() {
        void formik.setFieldTouched('phone', true);
    };
    (0,react.useEffect)(function() {
        if (!phoneRef.current) return;
        var resizeObserver = new ResizeObserver(function() {
            var ref, ref6;
            setWidth(((ref = phoneRef.current) === null || ref === void 0 ? void 0 : (ref6 = ref.parentElement) === null || ref6 === void 0 ? void 0 : ref6.offsetWidth) || 0);
        });
        resizeObserver.observe(phoneRef.current);
        return function() {
            return resizeObserver.disconnect();
        };
    }, []);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        phoneWidth: phoneWidth,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFormWrapper, {
            onSubmit: formik.handleSubmit,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FlexInputsWrapper, {
                    container: true,
                    alignItems: "flex-start",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(UserDataInputWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((lib_default()), {
                                localization: ru,
                                country: phones/* settings.country */.X.country,
                                onlyCountries: phones/* settings.countries */.X.countries,
                                masks: phones/* settings.masks */.X.masks,
                                value: formik.values.phone.value,
                                onChange: handleChange,
                                onBlur: handleBlur,
                                isValid: Boolean(!formik.errors.phone),
                                countryCodeEditable: false,
                                disableCountryGuess: true,
                                disableDropdown: true,
                                inputProps: {
                                    ref: phoneRef
                                },
                                containerClass: "phone__container",
                                inputClass: "phone__form-control",
                                buttonClass: "phone__flag-dropdown",
                                dropdownClass: "phone__country-list"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                                marginTop: 8,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                    color: ((ref5 = formik.errors) === null || ref5 === void 0 ? void 0 : (ref1 = ref5.phone) === null || ref1 === void 0 ? void 0 : ref1.value) ? theme.palette.secondary.MAIN : theme.palette.core.DEEP_GRAY,
                                    children: ((ref2 = formik.errors.phone) === null || ref2 === void 0 ? void 0 : ref2.value) || t("returnPrintForm:".concat(formik.values.type, ".hint"))
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                    tabIndex: 0,
                    type: "submit",
                    "data-testid": "submit-btn",
                    disabled: !formik.isValid,
                    isLoading: isFormSubmitting,
                    children: t('core:continue')
                })
            ]
        })
    }));
};

;// CONCATENATED MODULE: ./components/shared/SignInForm/index.ts


// EXTERNAL MODULE: ./components/shared/UnfinishedBooking/index.ts + 4 modules
var UnfinishedBooking = __webpack_require__(38240);
// EXTERNAL MODULE: ./components/ui/Container/index.ts + 2 modules
var Container = __webpack_require__(96429);
// EXTERNAL MODULE: ./components/ui/Paper/index.ts + 2 modules
var Paper = __webpack_require__(19365);
// EXTERNAL MODULE: ./core/constants.ts
var constants = __webpack_require__(43566);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/Trans.js + 1 modules
var Trans = __webpack_require__(59186);
// EXTERNAL MODULE: ./node_modules/react-use/esm/useUpdateEffect.js + 1 modules
var useUpdateEffect = __webpack_require__(54021);
;// CONCATENATED MODULE: ./utilities/updateQuery/updateQuery.ts
var updateQuery = function(params) {
    var _location = window.location, pathname = _location.pathname, host = _location.host, protocol = _location.protocol;
    var url = "".concat(protocol, "//").concat(host).concat(pathname, "?").concat(params);
    window.history.pushState({
        path: url
    }, '', url);
};

;// CONCATENATED MODULE: ./components/pages/Home/hooks/useFormVariant/hook.ts




var useFormVariant = function() {
    var router = (0,next_router.useRouter)();
    var getFormVariant = function() {
        var query = router.query;
        if ('refund' in query) return 'refund';
        if ('print' in query) return 'print';
        return 'search';
    };
    var getFormattedString = function(params) {
        return params.toString().replace('=', '');
    };
    var ref = (0,react.useState)(getFormVariant()), formVariant = ref[0], setStateFormVariant = ref[1];
    var appendParams = function(variant) {
        var params = new URLSearchParams();
        if (variant === 'refund') params.append('refund', '');
        if (variant === 'print') params.append('print', '');
        return params;
    };
    var setFormVariant = function(variant) {
        var params = appendParams(variant);
        var paramsLength = Array.from(params).length;
        if (paramsLength) void updateQuery(getFormattedString(params));
        void setStateFormVariant(variant);
    };
    (0,useUpdateEffect/* default */.Z)(function() {
        void setFormVariant(getFormVariant());
    }, [
        router
    ]);
    return formVariant;
};

;// CONCATENATED MODULE: ./components/pages/Home/hooks/useFormVariant/index.ts


;// CONCATENATED MODULE: ./components/pages/Home/libs/FormSelector/styles.ts


function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        ""
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = styles_taggedTemplateLiteral([
        "\n  @media only screen and (max-width: 630px) {\n    margin-left: auto;\n  }\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = styles_taggedTemplateLiteral([
        "\n  width: 1px;\n  height: 13px;\n  margin: 0 21px;\n  background-color: ",
        ";\n\n  @media only screen and (max-width: 365px) {\n    height: 10px;\n    margin: 0 14px;\n  }\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = styles_taggedTemplateLiteral([
        "\n      font-weight: 700;\n      opacity: 1;\n    "
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: inline-flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  transition: all 0.2s ease;\n  font-size: 14px;\n  font-weight: 400;\n  cursor: pointer;\n  opacity: 0.7;\n  color: ",
        ";\n  &:before {\n    content: attr(data-title) ' ';\n    font-weight: bold;\n    visibility: hidden;\n    overflow: hidden;\n    user-select: none;\n    pointer-events: none;\n    height: 0;\n  }\n\n  &:hover {\n    opacity: 0.9;\n  }\n\n  ",
        "\n\n  @media only screen and (max-width: 630px) {\n    text-align: left;\n    line-height: 18px;\n  }\n\n  @media only screen and (max-width: 365px) {\n    font-size: 13px;\n  }\n"
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
var styles_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8ac58b52-0"
})(styles_templateObject());
var FormSelectorFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* Flex */.k).withConfig({
    componentId: "sc-8ac58b52-1"
})(styles_templateObject1());
var Separator = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8ac58b52-2"
})(styles_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.palette.core.VERY_LIGHT_GRAY;
});
var StyledLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-8ac58b52-3"
})(styles_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.palette.core.WHITE;
}, function(param) {
    var selected = param.selected;
    return selected && (0,styled_components_browser_esm/* css */.iv)(styles_templateObject3());
});

;// CONCATENATED MODULE: ./components/pages/Home/libs/FormSelector/component.tsx






var FormSelector = function() {
    var t = (0,useTranslation/* default */.Z)('home').t;
    var formVariant = useFormVariant();
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
            marginBottom: 24,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormSelectorFlex, {
                container: true,
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                        href: "/",
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                            selected: formVariant === 'search',
                            "data-title": t('buyTicket'),
                            children: t('buyTicket')
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Separator, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                        href: "/?refund",
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                            selected: formVariant === 'refund',
                            "data-title": t('returnTicket'),
                            children: t('returnTicket')
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Separator, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                        href: "/?print",
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                            selected: formVariant === 'print',
                            "data-title": t('ticketPrint'),
                            children: t('myTickets')
                        })
                    })
                ]
            })
        })
    }));
};

;// CONCATENATED MODULE: ./components/pages/Home/libs/FormSelector/index.ts


// EXTERNAL MODULE: ./components/pages/Home/styles.ts
var styles = __webpack_require__(20742);
;// CONCATENATED MODULE: ./components/pages/Home/component.tsx





















// import { News } from './libs/News'

var HomePage = function() {
    var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
    var ref = (0,useTranslation/* default */.Z)(), t = ref.t, lang = ref.lang;
    var formVariant = useFormVariant();
    (0,react.useEffect)(function() {
        /* Analytics event */ (0,pageLoad/* pageLoadEvent */.a)(constants/* PAGE_NAMES.HOMEPAGE */.a3.HOMEPAGE, lang);
    }, []);
    var howToSteps = Array.from(t('home:howTo.steps', {}, {
        returnObjects: true
    }));
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaHead/* MetaHead */.w, {
                page: "home"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* MainScreen */.oK, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Background */.Aq, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                            src: "/bg.jpeg",
                            alt: "Онлайн сервис по покупке ж/д билетов Актобе - Мангистау, Актобе - Астана | bile-bile.kz",
                            title: "Онлайн сервис по покупке ж/д билетов Актобе - Мангистау, Актобе - Астана",
                            layout: "fill",
                            loading: "eager",
                            objectFit: "cover"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
                        height: "100%",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* StyledFlex */.G, {
                            container: true,
                            direction: "column",
                            justify: "center",
                            height: "100%",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                                    marginBottom: 24,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* TitleTypographyWrapper */.br, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                            color: theme.palette.text.ALTERNATIVE,
                                            as: "h1",
                                            typography: theme.typography.variants.title.H1,
                                            children: t('home:title')
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormSelector, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* FormWrapper */.n5, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paper/* Paper */.X, {
                                        background: theme.palette.core.WHITE,
                                        radius: 12,
                                        shadow: true,
                                        style: {
                                            height: 'auto'
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
                                            padding: 16,
                                            children: [
                                                formVariant === 'search' && /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchTicketsForm/* SearchTicketsForm */.l, {}),
                                                formVariant === 'print' && /*#__PURE__*/ (0,jsx_runtime.jsx)(SignInForm, {
                                                    type: Auth/* AuthPurpose.PRINT */.Y.PRINT
                                                }),
                                                formVariant === 'refund' && /*#__PURE__*/ (0,jsx_runtime.jsx)(SignInForm, {
                                                    type: Auth/* AuthPurpose.REFUND */.Y.REFUND
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* BlockWrapper */.qm, {
                bg: theme.palette.primary.MAIN,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PopularRoutes/* PopularRoutes */.e, {})
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                    paddingTop: 40,
                    paddingBottom: 40,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* SeoContent */.vA, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                                typography: theme.typography.variants.title.H1,
                                                children: t('home:about.title')
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* TextContent */.D7, {
                                                marginTop: 8,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                                    typography: theme.typography.variants.content.MAIN,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
                                                        i18nKey: "home:about.content",
                                                        components: {
                                                            0: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Bold */.d8, {})
                                                        }
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
                                        marginTop: 25,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                                typography: theme.typography.variants.title.H3,
                                                children: t('home:howTo.title')
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* TextContent */.D7, {
                                                marginTop: 8,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                                    typography: theme.typography.variants.content.MAIN,
                                                    children: t('home:howTo.content')
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* TextContent */.D7, {
                                                marginTop: 8,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* List */.aV, {
                                                    decimal: true,
                                                    children: howToSteps.map(function(step, idx) {
                                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                                            "data-index": "".concat(idx + 1, "."),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                                                children: step
                                                            })
                                                        }, step);
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* PaperCard */.Mg, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                            typography: theme.typography.variants.title.H3,
                                            children: t('home:direction.title')
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                                            marginTop: 8,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                                typography: theme.typography.variants.content.MAIN,
                                                color: theme.palette.core.DEEP_GRAY,
                                                children: t('home:direction.content')
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                                            marginTop: 16,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* List */.aV, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                                        typography: theme.typography.variants.content.BOLD,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                                            passHref: true,
                                                            href: "/aktob-mangs",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
                                                                    i18nKey: 'home:direction.directionAktobMangs',
                                                                    components: {
                                                                        0: /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                                                    }
                                                                })
                                                            })
                                                        })
                                                    })
                                                })
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UnfinishedBooking/* UnfinishedBooking */.Z, {})
        ]
    }));
};

;// CONCATENATED MODULE: ./components/pages/Home/index.ts


;// CONCATENATED MODULE: ./pages/index.tsx
var __N_SSP = true;



/***/ }),

/***/ 7476:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ settings; }
/* harmony export */ });
/* harmony import */ var interfaces_Country__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73918);

var prefixes = {
    ru: [
        900,
        901,
        902,
        903,
        904,
        905,
        906,
        908,
        909,
        910,
        911,
        912,
        913,
        914,
        915,
        916,
        917,
        918,
        919,
        920,
        921,
        922,
        923,
        924,
        925,
        926,
        927,
        928,
        929,
        930,
        931,
        932,
        933,
        934,
        936,
        937,
        938,
        939,
        941,
        950,
        951,
        952,
        953,
        954,
        955,
        956,
        958,
        960,
        961,
        962,
        963,
        964,
        965,
        966,
        967,
        968,
        969,
        970,
        971,
        977,
        978,
        980,
        981,
        982,
        983,
        984,
        985,
        986,
        987,
        988,
        989,
        991,
        992,
        993,
        994,
        995,
        996,
        997,
        999, 
    ],
    uz: [
        590,
        591,
        593,
        594,
        595,
        597,
        598,
        592
    ],
    by: [
        24,
        25,
        29,
        33,
        44
    ]
};
var settings = {
    country: interfaces_Country__WEBPACK_IMPORTED_MODULE_0__/* .CountryCode.KZ */ .C.KZ,
    countries: [
        interfaces_Country__WEBPACK_IMPORTED_MODULE_0__/* .CountryCode.KZ */ .C.KZ,
        // CountryCode.RU,
        interfaces_Country__WEBPACK_IMPORTED_MODULE_0__/* .CountryCode.UZ */ .C.UZ,
        interfaces_Country__WEBPACK_IMPORTED_MODULE_0__/* .CountryCode.KG */ .C.KG,
        interfaces_Country__WEBPACK_IMPORTED_MODULE_0__/* .CountryCode.TM */ .C.TM,
        interfaces_Country__WEBPACK_IMPORTED_MODULE_0__/* .CountryCode.BY */ .C.BY, 
    ],
    masks: {
        ru: '... ... ....',
        kz: '... ... ....',
        uz: '... ... ....',
        kg: '... ......',
        tm: '... ......',
        by: '.. ... ....'
    },
    expressions: [
        {
            country: interfaces_Country__WEBPACK_IMPORTED_MODULE_0__/* .CountryCode.KZ */ .C.KZ,
            regexp: new RegExp(/^(7)7[04567]\d\d{3}\d{4}$/)
        },
        {
            country: interfaces_Country__WEBPACK_IMPORTED_MODULE_0__/* .CountryCode.KG */ .C.KG,
            regexp: new RegExp(/^(996)\d{3}\d{6}$/)
        },
        {
            country: interfaces_Country__WEBPACK_IMPORTED_MODULE_0__/* .CountryCode.TM */ .C.TM,
            regexp: new RegExp(/^(993)\d{3}\d{6}$/)
        },
        {
            country: interfaces_Country__WEBPACK_IMPORTED_MODULE_0__/* .CountryCode.RU */ .C.RU,
            regexp: new RegExp("^(7)(".concat(prefixes.ru.join('|'), ")\\d{3}\\d{4}$"))
        },
        {
            country: interfaces_Country__WEBPACK_IMPORTED_MODULE_0__/* .CountryCode.UZ */ .C.UZ,
            regexp: new RegExp("^(998)(".concat(prefixes.uz.join('|'), ")\\d{3}\\d{4}$"))
        },
        {
            country: interfaces_Country__WEBPACK_IMPORTED_MODULE_0__/* .CountryCode.BY */ .C.BY,
            regexp: new RegExp("^(375)(".concat(prefixes.by.join('|'), ")\\d{3}\\d{4}$"))
        }, 
    ]
};


/***/ }),

/***/ 86318:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ getLocalStorageItem; }
/* harmony export */ });
var getLocalStorageItem = function(key) {
    var value = localStorage.getItem(key);
    if (!value) return value;
    return JSON.parse(value);
};


/***/ }),

/***/ 10047:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ setLocalStorageItem; }
/* harmony export */ });
var setLocalStorageItem = function(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
};


/***/ }),

/***/ 34306:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a$": function() { return /* reexport */ validatePhone; }
});

// UNUSED EXPORTS: getRegularExpression, validate

// EXTERNAL MODULE: ./schemas/phones/index.ts
var phones = __webpack_require__(7476);
;// CONCATENATED MODULE: ./utilities/validatePhone/validatePhone.ts

function getRegularExpression(countryCode) {
    return phones/* settings.expressions.find */.X.expressions.find(function(param) {
        var country = param.country;
        return country === countryCode;
    });
}
function validate(value, ctx, message, createError) {
    var countryCode = ctx.parent.countryCode;
    var expression = getRegularExpression(countryCode);
    var isValid = expression === null || expression === void 0 ? void 0 : expression.regexp.test(value);
    if (!isValid) return createError({
        path: ctx.path,
        message: message
    });
    return true;
}
function validatePhone() {
    var message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 'not valid';
    return this.test('phone', function(value, ctx) {
        var createError = this.createError;
        return validate(value, ctx, message, createError);
    });
}

;// CONCATENATED MODULE: ./utilities/validatePhone/index.ts



/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [675,474,890,243,517,38,561,327,774,888,179], function() { return __webpack_exec__(45301); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);